import axios from "axios";

const API_URL = "https://api.jshmcsl.com/api/admin"; 

export const adminLogin = async (data) => {
  try {
    const res = await axios.post(`${API_URL}/login`, data);
    return res.data; 
  } catch (err) {
    if (err.response && err.response.data) {
      return { success: false, message: err.response.data.message };
    }
    return { success: false, message: err.message };
  }
};
